import { Box, TextField, Button } from "@mui/material";
import ContainedButton from "../../components/ui/ContainedButton";
import ModalComp from "../../themes/Model";

const EditLabelModal = ({ isModalOpen, setIsModalOpen, currentEditLabel, newSynonym, setNewSynonym, handleSave }) => {
    const modalContent = (<Box>
        <TextField
            label="Label"
            value={currentEditLabel}
            variant="outlined"
            InputProps={{ readOnly: true }}
            fullWidth
            sx={{ backgroundColor: "#f8f9fa", cursor: "not-allowed", mb: 2 }}
        />
        <TextField
            label="What is this label referred as in the document?"
            value={newSynonym}
            onChange={(e) => setNewSynonym(e.target.value)}
            variant="outlined"
            fullWidth
            sx={{ mb: 3 }}
        />

    </Box>)

    const actionButtons = (
        <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 1 }}>
            <Button
                variant="outlined"
                size="small"
                sx={{ fontSize: 12, color: "black", borderColor: "#707070" }}
                onClick={() => setIsModalOpen(false)}
            >
                Cancel
            </Button>
            <ContainedButton onClick={handleSave}>Save</ContainedButton>
        </Box>
    )
    return (

        <>
            <ModalComp
                open={isModalOpen}
                handleClose={() => setIsModalOpen(false)}
                title={
                    <span style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                        {currentEditLabel}
                    </span>
                }
                modalContent={modalContent}
                modelButtons={actionButtons}
                datePickerStyle={{ width: "48%", margin: "5px" }}
                themeStyles={{
                    boxStyle: {
                        width: "682px",
                        height: "auto",
                        margin: "auto",
                        marginTop: "80px",
                    },
                    titleStyle: {
                        fontSize: "18px",
                        fontWeight: 600,
                        color: "#000",
                        backgroundColor: "#F4F4F4",
                        padding: "24px",
                        position: "sticky",
                        top: 0,
                        zIndex: 10,
                    },
                    fieldStyle: { width: "100%", marginTop: "20px" },
                    actionButtonContainerStyle: {
                        padding: "0 20px 20px 20px",
                    },
                }}
            />
        </>

    );
};

export default EditLabelModal;
